import React from 'react';
import PropTypes from 'prop-types';
import ShippingLabel from '@prisjakt/ui-shipping-label';
import PriceNotice from '@prisjakt/ui-price-notice';

import StoreBadgeList from '../../../store-badge-list';
import StoreInfoList from './store-info-list';
import StoreLink from './store-link';
import RecommendedRetailer from './recommended-retailer';

import * as S from './styles';

const StoreInfo = ({
  brand,
  storeInfo,
  storeLink,
  storeName,
  storeBadges,
  brandRecommendedRetailer,
  price,
  priceType,
}) => (
  <>
    <S.StoreInfoRow>
      <div>
        <StoreInfoList storeInfo={storeInfo} />
        <StoreLink link={storeLink} name={storeName} />
        {brandRecommendedRetailer && brand && (
          <RecommendedRetailer {...brand} />
        )}
      </div>
      <div>
        {price && price.inclShipping && (
          <S.StoreInfoRowItem>
            <ShippingLabel
              toneDown
              exclShipping={price.exclShipping}
              inclShipping={price.inclShipping}
            />
          </S.StoreInfoRowItem>
        )}
        {priceType && priceType !== 'normal' && (
          <S.StoreInfoRowItem>
            <PriceNotice
              toneDown
              type={priceType}
              textAtBottom={false}
              centerAlign={false}
            />
          </S.StoreInfoRowItem>
        )}
        {storeBadges && <StoreBadgeList badges={storeBadges} />}
      </div>
    </S.StoreInfoRow>
  </>
);

const { string, bool, arrayOf, shape, number, object } = PropTypes;

StoreInfo.propTypes = {
  brand: shape({
    id: number,
    name: string,
    logo: string,
  }),
  storeName: string.isRequired,
  storeInfo: arrayOf(string),
  storeLink: string,
  storeBadges: arrayOf(object),
  brandRecommendedRetailer: bool,
  price: shape({
    inclShipping: number,
    exclShipping: number,
  }),
  priceType: string,
};

StoreInfo.defaultProps = {
  storeLink: undefined,
  storeBadges: [],
  storeInfo: null,
  brand: null,
  brandRecommendedRetailer: false,
  price: undefined,
  priceType: undefined,
};

export default StoreInfo;
